import { render } from "./EditProducts.vue?vue&type=template&id=738caa2c"
import script from "./EditProducts.vue?vue&type=script&lang=js"
export * from "./EditProducts.vue?vue&type=script&lang=js"

import "./EditProducts.vue?vue&type=style&index=0&id=738caa2c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__